import React from 'react';
import styles from './PictureButton.module.scss';
import PictoMan1 from '@src/assets/PictoMan1.png';
import PictoMan2 from '@src/assets/PictoMan2.png';
import IR from '@src/assets/IR.png';
import IS from '@src/assets/IS.png';

interface PictureButtonProps {
    type: 'majeur' | 'incapable' | 'IrOption' | 'IsOption';
    onClick: () => void;
}

const buttonConfig = {
    majeur: {
        src: PictoMan1,
        alt: 'Majeur sans restriction',
        width: 146,
        height: 114,
        text: 'Majeur sans restriction',
    },
    incapable: {
        src: PictoMan2,
        alt: 'Majeur incapable',
        width: 146,
        height: 114,
        text: 'Majeur incapable',
    },
    IrOption: {
        src: IR,
        alt: 'Impôt sur le revenu des personnes physiques',
        width: 106,
        height: 103,
        text: 'Impôt sur le revenu des personnes physiques',
    },
    IsOption: {
        src: IS,
        alt: 'Impôt sur les sociétés',
        width: 106,
        height: 103,
        text: 'Impôt sur les sociétés',
    },
};

const PictureButton: React.FC<PictureButtonProps> = ({ type, onClick }) => {
    const { src, alt, width, height, text } = buttonConfig[type] || {};

    return (
        <button className={styles.button} onClick={onClick} disabled={!src}>
            {src && <img src={src} alt={alt} width={width} height={height} />}
            <p>{text}</p>
        </button>
    );
};

export default PictureButton;
